import React from 'react';

import LoadingIndicator from '@dashboard/components/loading/LoadingIndicator';
import { Box } from '@mui/material';

import ErrorMessage from '../components/ErrorMessage';

const BACKGROUND_SX = {
  display: 'flex',
  justifyContent: 'center',
  bgcolor: 'rgba(255, 255, 255, 0.25)',
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  transition: 'background-color 0.2s',
};

type Props = {
  loading: boolean;
  errorMessage: string | null;
};
export default function PreviewModal({ loading, errorMessage }: Props) {
  if (loading) {
    return (
      <Box sx={BACKGROUND_SX}>
        <LoadingIndicator />
      </Box>
    );
  }
  return <ErrorMessage message={errorMessage} />;
}
